import { publicClient, privateClient } from './client';
import { OrderStatus } from './OrderStatus';

const customOrderStatus = (pub: boolean) => new OrderStatus(pub ? publicClient : privateClient);
export default customOrderStatus;
